import { Link, useNavigate, useParams } from "react-router-dom";
import patient from "../../../../assets/img/patient.jpg";
import React, { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../../components/text-area";
import {
  ADMINPROMPTS,
  DIAGONASTIC_TOOL,
  PRACTICE_FRAMEWORK,
} from "../../../../action/apiPath";
import { CallWithAuth } from "../../../../action/apiActions";
import { showToast } from "../../../../util/toastHelper";
import Loading from "react-fullscreen-loading";
import { ADMINPROMPTPAGE } from "../../../../util/path";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */

const AdminPromptsPageAddOrEdit = ({ ...props }) => {
  const { isEdit } = props;

  const { id } = useParams();

  console.log("isEdit", isEdit);

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const textareaRef = useRef(null);
  const [practiceFrameworks, setPracticeFrameworks] = useState([]);
  const [diagnostic_tool, setDiagnosticTool] = useState([]);

  const [apiEndpointNameList, setApiEndpointNameList] = useState([
    { value: "collateral", level: "Collateral" },
    { value: "background_info", level: "Background Information" },
    { value: "mse", level: "Mental Status Examination (MSE)" },
    { value: "standardised_assessment", level: "Standardised Assessment" },
    { value: "clinical_interviews", level: "Clinical Interviews" },
    { value: "clinicalnote", level: "Clinical Note" },
    { value: "formulation", level: "Formulation" },
    { value: "diagnose", level: "Diagnosis" },
    { value: "recommendation", level: "Recommendation" },
    { value: "recommendations", level: "Recommendations" },
    { value: "assessment_data", level: "Assessment Data"}
  ]);

  const [formData, setFormData] = useState({
    selectRole: null,
    practiceFrameworkId: null,
    diagnosticToolId: null,
    apiEndpointName: null,
    promtText: null,
  });

  React.useEffect(() => {
    if (id && isEdit) {
      getSpecificPrompts();
    }
  }, [id, isEdit]);

  const getSpecificPrompts = async () => {
    try {
      if (!id) {
        return;
      }
      setIsLoading(true);
      const response = await CallWithAuth("GET", `${ADMINPROMPTS}/${id}`);
      if (response.res.status == 200) {
        console.log(response.res?.data?.data);
        let apiData = response.res?.data?.data;
        setFormData((prev) => ({
          ...prev,
          selectRole: apiData?.selectRole || null,
          practiceFrameworkId: apiData?.practiceFrameworkId || null,
          diagnosticToolId: apiData?.diagnosticToolId || null,
          apiEndpointName: apiData?.apiEndpointName || null,
          promtText: apiData?.promtText || null,
        }));

        //   setPrmoptsList(response?.res?.data?.data);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height based on scrollHeight
    }
  };

  const practiceFrameworksApiCall = async () => {
    try {
      const response = await CallWithAuth("GET", PRACTICE_FRAMEWORK);
      if (response.res.data && response.res.data.statusCode === 200) {
        setPracticeFrameworks(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
  };
  const diagonastictoolApiCall = async () => {
    try {
      const response = await CallWithAuth("GET", DIAGONASTIC_TOOL);
      if (response.res.data && response.res.data.statusCode === 200) {
        setDiagnosticTool(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    practiceFrameworksApiCall();
    diagonastictoolApiCall();
  }, []);
  // Re-run on text change
  const [prompt, setPrompt] = useState({});

  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [prompt]);
  //   useEffect(() => {
  //     getPromptData();
  //   }, []);
  //   const getPromptData = async () => {
  //     try {
  //       const response = await CallWithAuth("GET", ADMINPROMPTS);
  //       if (response.res.status == 200) {
  //         setPrompt((prev) => ({
  //           ...prev,
  //           background_info: response.res.data.data.background_info,
  //           collateral: response.res.data.data.collateral,
  //           mse: response.res.data.data.mse,
  //           standardised_assessment:
  //             response.res.data.data.standardised_assessment,
  //           clinical_interviews: response.res.data.data.clinical_interviews,
  //           formulation: response.res.data.data.formulation,
  //           diagnose: response.res.data.data.diagnose,
  //           recommendation: response.res.data.data.recommendation,
  //         }));
  //         // setPrompt(response.res.data.data);
  //       } else {
  //         showToast("error", response.res.data.message);
  //       }
  //       setIsLoading(false);
  //     } catch (err) {
  //       setIsLoading(false);
  //     }
  //   };

  const validatePromptData = (data) => {
    const errors = {};

    if (!formData.selectRole) {
      errors.selectRole = "Doctor role is required.";
    }

    // if (!formData.practiceFrameworkId) {
    //   errors.practiceFrameworkId = "Practice framework is required.";
    // }

    if (!formData.diagnosticToolId) {
      errors.diagnosticToolId = "Diagnostic tool is required.";
    }

    if (!formData.apiEndpointName) {
      errors.apiEndpointName = "API endpoint name is required.";
    }

    if (!formData.promtText || formData.promtText.trim() === "") {
      errors.promtText = "Prompt text is required.";
    }

    return errors;
  };
  const savePrompts = async () => {
    try {
      const errors = validatePromptData(formData); // Replace `promptData` with your state variable

      if (Object.keys(errors).length > 0) {
        const firstError = Object.values(errors)[0]; // Get the first error message
        // toast.error(firstError, { position: toast.POSITION.TOP_RIGHT });
        showToast("error", firstError);

        return;
      }
      console.log(formData);

      //   return;
      let url = ADMINPROMPTS;
      let method = "POST";
      
      if (isEdit && id) {        
        url = `${ADMINPROMPTS}`;     

        method="PATCH";
        formData.id = id;
      }
      setIsLoading(true);
      const response = await CallWithAuth(method, url, formData);
      console.log("response", response);

      if (response.res.status == 200 || response.res.status == 201) {
        showToast("success", response.res.data.message);
        setTimeout(() => {
          navigate(`${ADMINPROMPTPAGE}`);
        }, 2000);
      } else {
        if (Array.isArray(response.res.data.message)) {
          showToast("error", response.res.data.message[0]);
        } else {
          showToast("error", response.res.data.message);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);

      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleRoleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleFrameworkChange = (e) => {
    setFormData({
      ...formData,
      practiceFrameworkId: e.target.value,
    });
  };
  const handleDiagnosticToolChange = (e) => {
    setFormData({
      ...formData,
      diagnosticToolId: e.target.value,
    });
  };

  const handleApiEndpointChange = (e) => {
    setFormData({
      ...formData,
      apiEndpointName: e.target.value,
    });
  };
  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <Loading
            loading
            background="rgba(236, 240, 241, 0.7)"
            loaderColor="#3498db"
          />
        </>
      )}

      <section class="create_account_block">
        <div class="site_container">
          <div class="create_account_form">
            <div class="field_block">
              <label for="">Select Role</label>
              <div class="input_check_grp">
                <div class="item">
                  <input
                    type="radio"
                    name="selectRole"
                    value="psychiatrist"
                    checked={formData?.selectRole === "psychiatrist"}
                    onChange={handleRoleChange}
                  />
                  <span>psychiatrist </span>
                </div>
                <div class="item">
                  <input
                    type="radio"
                    name="selectRole"
                    value="psychologist"
                    checked={formData?.selectRole === "psychologist"}
                    onChange={handleRoleChange}
                  />
                  <span>psychologist </span>
                </div>
              </div>
            </div>

            <div className="field_block">
              <label>Select Practice Framework</label>
              <select
                name="practice_framework"
                id="practice_framework"
                onChange={handleFrameworkChange}
                value={formData?.practiceFrameworkId || ""}
                disabled={isEdit}
              >
                <option value="">Select Practice Framework</option>
                {practiceFrameworks?.map((framework) => (
                  <option key={framework.id} value={framework.id}>
                    {framework.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="field_block">
              <label>Select Provisional Diagnostic Tool</label>
              <select
                name="diagnostic_tool"
                id="diagnostic_tool"
                onChange={handleDiagnosticToolChange}
                value={formData?.diagnosticToolId || ""}
              >
                <option value="">Select Diagnostic Tool</option>
                {diagnostic_tool?.map((tool) => (
                  <option key={tool.id} value={tool.id}>
                    {tool.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="field_block">
              <label>Select Api endPoint</label>
              <select
                name="apiEndpointName"
                id="apiEndpointName"
                onChange={handleApiEndpointChange}
                value={formData?.apiEndpointName || ""}
                disabled={isEdit}
              >
                <option value="">Select Api Endpoint Name</option>
                {apiEndpointNameList?.map((tool) => (
                  <option key={tool.value} value={tool.value}>
                    {tool.level}
                  </option>
                ))}
              </select>
            </div>
            <div className="field_block">
              <label>Prompt Text</label>
              <Textarea
                name="promtText"
                value={formData?.promtText}
                onChange={handleChange}
                //   fieldName="background info"
              />
            </div>

            <button onClick={savePrompts} className="button_save_prompts">
              {isEdit ? "Update" : "Save Prompts"}
            </button>
          </div>
        </div>
      </section>
      {/* <section className="site_container">
          <div className="row mx-auto mt-5">
            <div className="col-12 prompts_inner_block">
              <Textarea
                name="background_info"
                value={prompt.background_info}
                onChange={handleChange}
                fieldName="background info"
              />
            </div>

            
            <button onClick={savePrompts} className="button_save_prompts mt-5">
              Save Prompts
            </button>
          </div>
        </section> */}
    </>
  );
};
export default AdminPromptsPageAddOrEdit;
